<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" fill="none">
    <g id="Group 271" filter="url(#filter0_d_5090_2962)">
      <g id="Group 270">
        <circle
          id="Ellipse 33"
          cx="28"
          cy="24"
          r="22.75"
          fill="#525252"
          stroke="#525252"
          stroke-width="2.5" />
        <g id="Group 133">
          <circle
            id="Ellipse 33_2"
            cx="27.9969"
            cy="24.0008"
            r="19.2"
            fill="#1E192E" />
          <path
            id="Vector"
            d="M27.9969 4.80078C17.3985 4.80078 8.79688 13.4024 8.79688 24.0008C8.79688 34.5992 17.3985 43.2008 27.9969 43.2008C38.5953 43.2008 47.1969 34.5992 47.1969 24.0008C47.1969 13.4024 38.5953 4.80078 27.9969 4.80078ZM27.9969 10.5608C31.1841 10.5608 33.7569 13.1336 33.7569 16.3208C33.7569 19.508 31.1841 22.0808 27.9969 22.0808C24.8097 22.0808 22.2369 19.508 22.2369 16.3208C22.2369 13.1336 24.8097 10.5608 27.9969 10.5608ZM27.9969 37.8248C23.1969 37.8248 18.9537 35.3672 16.4769 31.6424C16.5345 27.8216 24.1569 25.7288 27.9969 25.7288C31.8177 25.7288 39.4593 27.8216 39.5169 31.6424C37.0401 35.3672 32.7969 37.8248 27.9969 37.8248Z"
            fill="#525252" />
        </g>
        <circle
          id="Ellipse 32"
          cx="27.9969"
          cy="24.0008"
          r="20.45"
          stroke="#1E192E"
          stroke-width="2.5" />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_5090_2962"
        x="0"
        y="0"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5090_2962" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5090_2962"
          result="shape" />
      </filter>
    </defs>
  </svg>
</template>
